// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__Pl-5y","tableContainer":"styles_tableContainer__2lE8s","rowsWrapper":"styles_rowsWrapper__3opJ2"};